import React from 'react';
import { RestAddressData } from '../../../hooks/useAddress';
import { AmazonShippingAddressPreview } from '../AmazonShippingAddressPreview';
import { AmazonPaymentMethodPreview } from '../AmazonPaymentMethodPreview';
import './AmazonShippingAndPaymentPreview.scss';

type Props = {
  address: RestAddressData;
};

export const AmazonShippingAndPaymentPreviewReadOnly: React.FC<Props> = ({ address }) => (
  <div className="AmazonShippingAndPaymentPreview">
    <div className="AmazonShippingAndPaymentPreview__section">
      <AmazonShippingAddressPreview address={address} />
    </div>
    <div className="AmazonShippingAndPaymentPreview__section">
      <AmazonPaymentMethodPreview />
    </div>
  </div>
);
